import { useEffect } from "react";
import { Input, Form, Select } from "antd";
import { getLangList } from '@/lib/i18n';
import { getOptionArray, selectFilterOption, modalFromLayout } from "@/lib/antdElementFunction";
import { ClassType, TeacherType } from './types';

interface Props {
  form: any;
  info: ClassType;
  handleType: string;
  teacherArray: TeacherType[];
}

function ModalClass(props: Props) {
  const { form, info, handleType, teacherArray } = props;
  const studentListT: any = getLangList("studentList");

  useEffect(() => {
    const { className, classroom, teacherId } = info ?? {};

    handleType === 'update' && form.setFieldsValue({ className, classroom, teacherId });
  }, [form, info, handleType]);

  function formatTeacherData() {
    const dataArray = teacherArray.map((item: TeacherType) => ({ label: `${item.nameCn}-${item.nameEn}`, value: item.userAccountId }));
    return dataArray;
  };

  return (
    <Form
      className="admin-form"
      style={{ marginTop: 20 }}
      {...modalFromLayout}
      form={form}
    >
      <Form.Item
        label={studentListT.CLASS_NAME}
        name="className"
        rules={[{ required: true }]}
      >
        <Input />
      </Form.Item>
  
      <Form.Item
        label={studentListT.CLASSROOM}
        name="classroom"
        rules={[{ required: true }]}
      >
        <Input />
      </Form.Item>
  
      <Form.Item
        label={studentListT.TEACHER}
        name="teacherId"
        rules={[{ required: true }]}
      >
        <Select
          showSearch
          style={{ width: "100%" }}
          optionFilterProp="children"
          filterOption={(input: any, option: any) => selectFilterOption(input, option)}
        >
          {getOptionArray(formatTeacherData())}
        </Select>
      </Form.Item>
    </Form >
  );
}

export default ModalClass;